export default __webpack_public_path__ + "static/media/metamask-setup_image_3.fd3621de.jpg";